import { STATUSES } from './constants'

const REASONS = {
  TERMINAL: 'Promotion is closed',
  AFTER_ACTIVATION: 'Cannot be changed after activation',
  AFTER_TICKETS: 'Cannot be changed after tickets have been sold',
  EXTEND_ONLY: 'Can only be extended, not shortened',
}

const TERMINAL = [STATUSES.CLOSED, STATUSES.COMPLETED, STATUSES.CANCELLED]

const free = { locked: false, extendOnly: false, reason: null }
const locked = (reason) => ({ locked: true, extendOnly: false, reason })
const extendOnly = (reason = REASONS.EXTEND_ONLY) => ({
  locked: false,
  extendOnly: true,
  reason,
})

export const getFieldLock = (field, status) => {
  if (!status) return free
  if (TERMINAL.includes(status)) return locked(REASONS.TERMINAL)

  switch (field) {
    case 'name':
      return free

    case 'prize_value':
    case 'ticket_price':
      if (status === STATUSES.ACTIVE_TICKETS_SOLD) {
        return locked(REASONS.AFTER_TICKETS)
      }
      return free

    case 'promotion_start_time':
      if (
        status === STATUSES.ACTIVE_NO_TICKETS_SOLD ||
        status === STATUSES.ACTIVE_TICKETS_SOLD
      ) {
        return locked(REASONS.AFTER_ACTIVATION)
      }
      return free

    case 'sales_close_time':
      return extendOnly()

    case 'draw_time':
      if (status === STATUSES.ACTIVE_TICKETS_SOLD) return extendOnly()
      return free

    default:
      return free
  }
}
